// extracted by mini-css-extract-plugin
export var form = "_di-0";